export const isDefined = <T = unknown>(arg: T | undefined): arg is T => {
  return arg !== undefined;
};
